// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.waveform_waveform__q5Uxv {
  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 75%;
  height: 50%;
}

.waveform_waveform__q5Uxv .waveform_bar__l4XTc {
  width: 100%;
  height: 100%;
  margin: 1%;

  background: white;

  animation-name: waveform_wave__XbWrO;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes waveform_wave__XbWrO {
  0% {
    height: 15%;
    opacity: 0.35;
  }
  100% {
    height: 70%;
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/waveform/waveform.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;;EAEV,iBAAiB;;EAEjB,oCAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF","sourcesContent":[".waveform {\n  position: absolute;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 75%;\n  height: 50%;\n}\n\n.waveform .bar {\n  width: 100%;\n  height: 100%;\n  margin: 1%;\n\n  background: white;\n\n  animation-name: wave;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n}\n\n@keyframes wave {\n  0% {\n    height: 15%;\n    opacity: 0.35;\n  }\n  100% {\n    height: 70%;\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"waveform": `waveform_waveform__q5Uxv`,
	"bar": `waveform_bar__l4XTc`,
	"wave": `waveform_wave__XbWrO`
};
export default ___CSS_LOADER_EXPORT___;
